import { get, post } from '@/api/axios';
import { CustomerRegistrationEndpoints } from '@/api/endpoints/CustomerRegistrationEndpoints';
import { type CustomerRegistrationConfirmationDto } from '@/app/models/CustomerRegistrationConfirmationDto';
import { getProjectEnvVariables } from '@/shared/projectEnvVariables';

const apiRoot = () => ({
  baseURL: getProjectEnvVariables().envVariables.VITE_APP_API_URL.replace(/\/admin\/?$/, ''),
});

export const getCustomerRegistration = (token: string) =>
  get<CustomerRegistrationConfirmationDto>(CustomerRegistrationEndpoints.find(token), apiRoot());

export const confirmCustomerRegistration = (token: string) =>
  post<CustomerRegistrationConfirmationDto>(CustomerRegistrationEndpoints.confirm(token), undefined, apiRoot());
